/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * 用户授信相关按钮（组），根据不同的用户授信状态展示对应的可操作按钮
 * 支付宝小程序场景使用
 */

import { Component, Mixins, Prop } from 'vue-property-decorator';
import type { VNode } from 'vue';
import FinanceBusiness from '@/mixins/finance-business';
import { Dialog } from '@hb/coffee';
import { namespace } from 'vuex-class';
import { StateType as HomeStateType } from '@/views_v2/home/types';
import platform from '@/shared/utils/platform';
import AdvHomeCornerMark from '@/components/adv-components/adv-home-corner-mark';
import { creditTaskStatusTypeEnum, creditTaskSuspendSceneEnum } from '@/enums/autarkyUpgrade';
import TaglessButton from '../finance-credit-card/components/credit-button';

const HomeStore = namespace('home');

const style: Dictionary = require('./index.module.scss');

@Component
export default class AliminiCreditButtons extends Mixins(
  FinanceBusiness,
) {
  @Prop({
    type: String,
    default: 'dark',
  }) readonly type!: 'dark' | 'light';

  @Prop({
    type: Boolean,
    default: false,
  }) readonly newButton!: false;

  @HomeStore.State aliProductStatus!: HomeStateType['aliProductStatus'];

  private buttonName: VNode | string = '';

  // 是否授信过
  private get isCredit(): boolean {
    return !!this.creditData && this.creditData.creditStatus;
  }

  private onClickApply() {
    if ((platform.isAlipayMini || platform.isDingTalk) && !this.creditData) {
      return null;
    }
    const { dialogText } = this.aliProductStatus;

    if (dialogText) {
      this.$ubtPageButton(
        'finance_credit_blocked_dialog_show',
        'status',
        this.aliProductStatus.status || '',
      );

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      Dialog.alert({
        title: dialogText,
        confirmButtonText: '知道了',
        closeable: false,
      }).then(() => {
        this.$ubtPageButton(
          'finance_credit_blocked_dialog_hide',
          'status',
          this.aliProductStatus.status || '',
        );
      });

      return false;
    }

    return this.onApplyCredit('臻有钱_首页_领取额度_未激活');
  }

  // 申请额度 或 查看额度审核进度
  private get applyCreditButton(): VNode | null {
    if (this.creditData) {
      const {
        progressingTaskId, creditTaskStatus,
      } = this.creditData;
      const { buttonText } = this.aliProductStatus;

      /** 有 进行中授信任务 id */
      if (progressingTaskId) {
      /** 有进行中授信任务 id，且任务挂起状态（自营 B 失败，联营未补充资料） */
        if (creditTaskStatus === creditTaskStatusTypeEnum.HANG) {
          this.buttonName = '去补充资料';
        } else {
          this.buttonName = '额度审批中，请耐心等待';
        }
      } else {
        if (buttonText) {
          this.buttonName = buttonText;
        } else if (this.canReceiveAmount) {
          this.buttonName = '申请额度';
        } else {
          this.buttonName = '只差一步，继续申请';
        }
      }
    } else {
      this.buttonName = '申请额度';
    }

    if (this.newButton) {
      return (<TaglessButton
      buttonName={this.buttonName}
      onEmitClick={this.onClickApply.bind(this)}/>);
    }
    return (
      <div
        class={[
          style.button,
          style.applyCreditButton,
          style[`${this.type}Type`],
          !this.isCredit && style.taglessButton,
        ]}
        onClick={this.onClickApply.bind(this)}
      >
        {this.buttonName}
      </div>
    );
  }

  // 立即提现
  private get drawButton(): VNode | null {
    if (!this.creditData) {
      return null;
    }

    return (
      <div
        class={[
          style.button,
          style.drawButton,
          style[`${this.type}Type`],
          !this.isCredit && style.taglessButton,
        ]}
        onClick={this.onApplyProduct.bind(this, '臻有钱_首页_立即提现')}
      >
        去提现
      </div>
    );
  }

  // 我要还款
  private get repayButton(): VNode | null {
    return this.creditData && (
      <div
        class={[
          style.button,
          style[`${this.type}Type`],
          !this.isCredit && style.taglessButton,
        ]}
        onClick={this.onRepay.bind(this, '臻有钱_首页_我要还款')}
      >
        去还款
      </div>
    );
  }

  // 申请额度
  private get applyButton(): VNode | null {
    return this.creditData && (
      <div
        class={[
          style.button,
          style[`${this.type}Type`],
          !this.isCredit && style.taglessButton,
        ]}
        onClick={this.onApplyCredit.bind(this,
          'finance_tagless_ExpriedCreditApply')}
      >
        申请额度
      </div>
    );
  }

  private get buttonList(): (VNode | null)[] {
    const buttons: (VNode | null)[] = [];

    const { hasOrder, creditAmount, creditStatus } = this.creditData || {};

    if (hasOrder) {
      buttons.push(this.repayButton);
      // 有待还款订单，且授信额度失效，增加申请额度入口
      if (!creditStatus) {
        buttons.push(this.applyButton);
      }
    }

    if (!this.hasCredit) {
      // 没有可用额度，引导用户申请额度
      buttons.push(!hasOrder ? this.applyCreditButton : null);
    } else {
      // 用户有可用额度
      if (Number(creditAmount) > 0) {
        buttons.push(this.drawButton);
      } else {
        buttons.push(!hasOrder ? this.applyCreditButton : null);
      }
    }

    return buttons;
  }

  // 显示提现角标
  private get showApplyCorner(): boolean {
    const { creditAmount } = this.creditData || {};
    if (this.hasCredit && Number(creditAmount) > 0) {
      return true;
    }
    return false;
  }

  private render() {
    return (
      <div class={style.buttons}>
        <div class={style.buttonGroup}>
          {this.buttonList}
          {this.showApplyCorner && <AdvHomeCornerMark/>}
        </div>

        {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          this.getUpdatedIdentityPhotoDialog()
        }

      </div>
    );
  }
}
